
/* Pastilles de couleur a l'image du coloris + bascule de l'image principale. */
(function () {
  'use strict';

  /* Recadrage carre cote serveur : _240x240_crop_center. Sans ça le CSS rogne au hasard
     dans une photo portrait et on ne voit que le fond. */
  function carre(src) {
    var base = src.split('?')[0], q = src.indexOf('?') > -1 ? src.slice(src.indexOf('?')) : '';
    return base.replace(/(\.[a-z]+)$/i, '_300x400_crop_center$1') + q;
  }

  function racine() { return document.querySelector('[id*="__main"]'); }

  function slides(main) { return [...main.querySelectorAll('.product-single__media-slide')]; }

  function afficher(main, mediaId) {
    var cible = null, tous = slides(main);
    tous.forEach(function (s) {
      var id = s.getAttribute('data-id');
      if (String(id) === String(mediaId)) cible = s;
    });
    if (!cible) return false;
    tous.forEach(function (s) { s.classList.toggle('media--hidden', s !== cible); });
    // vignette correspondante : on la marque et on l'amene dans le champ de vision
    main.querySelectorAll('.product-single__thumbnail').forEach(function (t) {
      var actif = String(t.getAttribute('data-id')) === String(mediaId);
      t.classList.toggle('ol-vignette--active', actif);
      if (actif && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
    return true;
  }

  function champs(main) { return [...main.querySelectorAll('.radio__fieldset')]; }

  function choisie(main, produit) {
    var val = champs(main).map(function (fs) {
      var c = fs.querySelector('input.radio__input:checked');
      return c ? c.value : null;
    });
    return produit.variants.filter(function (v) {
      return v.options.every(function (o, i) { return val[i] == null || o === val[i]; });
    })[0];
  }

  function habiller(main, produit) {
    // une image par couleur -> pastille image
    var parCouleur = {};
    produit.variants.forEach(function (v) {
      var c = v.options[0];
      if (c && !parCouleur[c] && v.featured_image) parCouleur[c] = v.featured_image.src;
    });
    var fsCouleur = champs(main).filter(function (fs) {
      var l = fs.querySelector('.radio__legend__label');
      return l && (l.textContent || '').trim().toLowerCase().indexOf('couleur') === 0;
    })[0];
    if (!fsCouleur) return;
    fsCouleur.querySelectorAll('input.radio__input').forEach(function (inp) {
      var lab = fsCouleur.querySelector('label[for="' + inp.id + '"]');
      if (!lab) return;
      lab.title = inp.value;
      var src = parCouleur[inp.value];
      if (src) {
        /* en ligne : le theme impose sinon sa propre largeur et son background */
        lab.style.backgroundImage = 'url("' + carre(src) + '")';
        lab.style.backgroundSize = 'cover';
        lab.style.backgroundPosition = 'center 30%';
        lab.style.backgroundRepeat = 'no-repeat';
        lab.style.width = '46px';
        lab.style.minWidth = '46px';
        lab.style.height = '46px';
        lab.classList.add('ol-pastille--image');
      }
    });
  }

  function brancher(main, produit) {
    function maj() {
      var v = choisie(main, produit);
      if (v && v.featured_media) afficher(main, v.featured_media.id);
    }
    main.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('radio__input')) setTimeout(maj, 30);
    });
    // clic direct sur une vignette : on garde la main sur l'etat visuel
    main.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.product-single__thumbnail');
      if (t) setTimeout(function () { afficher(main, t.getAttribute('data-id')); }, 10);
    });
    maj();
  }

  function demarrer() {
    var main = racine();
    if (!main || main.dataset.olVariantes) return;
    var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!h) return;
    main.dataset.olVariantes = '1';
    fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { habiller(main, p); brancher(main, p); })
      .catch(function () {});
  }

  if (document.readyState !== 'loading') demarrer();
  else document.addEventListener('DOMContentLoaded', demarrer);
  document.addEventListener('shopify:section:load', demarrer);
})();
